import { Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import PageNotFound from "./pages/pageNotFound";
import MailLoginRequired from "./account/mailLoginRequired";
import MailLogin from "./pages/mail/login";
import MailLayout from "./components/mail/MailLayout";
import MailboxView from "./pages/mail/MailboxView";
import EmailDetailView from "./pages/mail/EmailDetailView";
import SettingsView from "./pages/mail/SettingsView";
import { ConfigProvider, notification } from "antd";
import { UserProvider } from "./context/UserContext";

import "./App.scss";

var theme = {
  primary: "#623ce7",
  verylight: "#623ce7",
  lightshadow: "0 0 0 2px rgb(5 5 5 / 20%)",
  light: "#ededed",
  dark: "#565656",
  verydark: "#565656",
};

notification.config({
  placement: "bottomLeft",
});

function App() {
  return (
    <HelmetProvider>
      <ConfigProvider
        // Dark mode
        theme={{
          algorithm: theme.lightAlgorithm,
          token: {
            colorPrimary: "#623ce7",
            fontFamily: "Inter, sans-serif",
            fontSize: 14,
          },
          components: {
            Tooltip: {
              fontSize: 12,
            },
            Select: {
              zIndex: 1000000,
              optionActiveBg: theme.verylight,
              optionSelectedBg: theme.light,
              optionPadding: "4px 8px",
              optionHeight: 28,
              activeShadow: "0 0 0 2px rgba(5, 5, 5, 0.1)",
            },
            Slider: {
              handleSize: 3,
              handleSizeHover: 6,
              handleLineWidth: 3,
              handleLineWidthHover: 3.5,
              railSize: 2,
              handleColor: theme.primary,
              railColor: theme.primary,
              handleActiveOutlineColor: theme.primary,
            },
            Notification: {
              fontSize: 12,
            },
          },
        }}
      >
      <UserProvider>
        <Routes>        
          <Route path="/" element={
            <MailLoginRequired redirect={"/login"}>
              <MailLayout />
            </MailLoginRequired>
          }>
            <Route path="mailboxes/label/:labelId" element={<MailboxView />} />
            <Route path="mailboxes/:path/search" element={<MailboxView />} />
            <Route path="mailboxes/:path" element={<MailboxView />} />
            <Route path="mailboxes/:path/:emailId" element={<EmailDetailView />} />
            <Route path="settings" element={<SettingsView />} />
            <Route index element={<MailboxView />} />
          </Route>
          <Route path="/login" element={<MailLogin />} />
          <Route path="*" exact element={<PageNotFound />} />
        </Routes>
      </UserProvider>
      </ConfigProvider>
    </HelmetProvider>
  );
}

export default App;
